import './Public.scss'
import { Outlet } from 'react-router-dom'
import { Layout } from 'antd'

export default ({ children }) => {
  return (
    <Layout className="layout-public">
      {children || <Outlet />}
    </Layout>
  )
}
